import { useContext, useState } from 'react'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import { useMutation } from '@apollo/client'
import { AuthContext } from '../../../../Auth/AuthContext'
import { objNameRoles } from '../../../../const/constRoles'
import Swal from 'sweetalert2'
import { DELETE_MIGRANTS_INTERNAL_NOTE, EDIT_MIGRANTS_INTERNAL_NOTE } from '../../../../graphql/Catalog/Migrants/migrantsInternalNotes'

const MigrantsInternalNotesMenuMessageContent = ({
  messageId,
  messageType, // 'internal' or 'external'
  messageContent,
  refetchMessages,
}) => {
  const roleMaster = objNameRoles.master
  const roleAdmin = objNameRoles.admin
  const { user } = useContext(AuthContext)
  const { showLoading, hideLoading } = useLoading()

  const [isOpen, setIsOpen] = useState(false)

  const [editMessageMutation] = useMutation(EDIT_MIGRANTS_INTERNAL_NOTE)
  const [deleteNote] = useMutation(DELETE_MIGRANTS_INTERNAL_NOTE)

  const closeDropdown = () => {
    const dropdown = document.querySelector('.dropdown-menu.show')
    if (dropdown) {
      dropdown.classList.remove('show')
    }
  }

  const handleDeleteNote = async (id) => {
    try {
      const response = await toastSweetAlert({
        mode: 'modalConfirmCancel',
        icon: 'warning',
        title: 'Eliminar mensaje',
        message: '¿Está seguro de que desea eliminar este mensaje?',
        confirmButtonText: 'Eliminar',
      })

      if (!response.isConfirmed) return

      showLoading()

      const { data } = await deleteNote({
        variables: {
          id: +id,
        },
      })

      if (data.deleteMigrantsInternalNote) {
        await refetchMessages()
        return toastSweetAlert({
          mode: 'ok',
          title: 'Mensaje eliminado',
          message: 'El mensaje ha sido eliminado correctamente.',
        })
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        title: 'Error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  const editMessage = async (id) => {
    try {
      const validateMessage = () => {
        const message = document.getElementById('editMessage').value
        if (message.trim() === '') {
          return Swal.showValidationMessage(
            'El mensaje no puede estar vacío. Por favor, ingrese un mensaje válido.'
          )
        }

        return true
      }
      const editMessage = await toastSweetAlert({
        mode: 'modalConfirmContent',
        title: 'Editar mensaje',
        confirmButtonText: 'Editar',
        content: (
          <div className="message-container">
            <textarea
              id="editMessage"
              className="form-control"
              rows="3"
              defaultValue={messageContent.text}
            ></textarea>
          </div>
        ),
        validator: () => validateMessage(),
      })

      if (!editMessage.isConfirmed) return

      showLoading()
      const messageNewContent = document.getElementById('editMessage').value
      const cleanMessage = messageNewContent.trim()

      const { data } = await editMessageMutation({
        variables: {
          id: +id,
          inputEditMessage: {
            text: cleanMessage,
          },
        },
      })

      if (data.updateMigrantsInternalNote) {
        await refetchMessages()
        return toastSweetAlert({
          mode: 'ok',
          title: 'Mensaje editado',
          message: 'El mensaje ha sido editado correctamente.',
        })
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <div
      className={`dropdown 
        ${
          messageContent.user_id !== user.idUser
            ? user.role === roleMaster || user.role === roleAdmin
              ? ''
              : 'd-none'
            : ''
        }
        
      `}
      key={messageId}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => closeDropdown()}
    >
      {/* <span
        onClick={() => handleDeleteNote(messageId)}
        title="Eliminar mensaje"
      >
        <i class="fas fa-times"></i>
      </span>
      <span onClick={() => editMessage(messageId)} title="Editar mensaje">
        <i class="fas fa-edit"></i>
      </span> */}
      <span
        className="btn"
        // type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-expanded="false"
        title="Opciones"
      >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <i class="fas fa-ellipsis-v"></i>
      </span>

      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li>
          <span
            className="dropdown-item"
            onClick={() => editMessage(messageId)}
          >
            <i className="fas fa-edit"></i> Editar mensaje
          </span>
        </li>
        <li>
          <span
            className="dropdown-item"
            onClick={() => handleDeleteNote(messageId)}
          >
            <i className="fas fa-trash"></i> Borrar mensaje
          </span>
        </li>
      </ul>
    </div>
  )
}

export default MigrantsInternalNotesMenuMessageContent
